<template>
  <div class="join-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner" src="@/assets/join/banner.jpg">
    <div class="news-text-content">
      <h3 style="margin-bottom: 20px;">人才理念</h3>
<!--      <div class="news-text-desc">人才理念是集团人才选用余留的基本原则是集团开展人力资源工作的指导思想和价值观念</div>-->
      <img src="@/assets/join/13.jpg">
    </div>
    <div class="work-content bg-gray">
        <div class="work-filter">
          <div class="work-title">职位筛选</div>
          <div class="work-search">
            <el-input v-model="query.title" placeholder="输入职位关键词"></el-input>
            <el-button style="float: right;" type="primary" @click="onSearch">搜索职位</el-button>
          </div>
          <div class="work-search">
            <el-select v-model="query.address" placeholder="工作地点" @change="changeHandle">
              <el-option v-for="(item,index) in addressArr" :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="query.type" placeholder="职能类型" style="margin-left: 10px;" @change="changeHandle">
              <el-option v-for="(item,index) in typeArr" :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      <div class="work-list">
        <div v-for="(item,index) in workList" :key="index" class="work-list-item" @click="workClick(item,index)">
          <div class="work-list-item-left">
            <div class="label-status">
              <span v-if="item.postLevel=='2'" class="level">急</span>
              <span class="post-name">{{item.title}}</span>
            </div>
            <div class="address-label">
              <span>{{getDictText(addressArr,item.address)}}</span>
              <span>|</span>
              <span>{{getDictText(typeArr,item.type)}}</span>
            </div>
          </div>
          <div class="work-list-item-right">
            <img src="@/assets/logobig.png">
            <div>发布时间：{{item.createTime}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import topNav from '@/components/base/top-nav'
import {fetchDict,fetchList} from '@/api/join.js'
import {formatTime} from '@/utils';
export default {
  name: "join",
  components:{
    topNav
  },
  data() {
    return {
      query:{
        current:1,
        size: 999,
        title: '',
        address:'',
        type:'',
        dept:''
      },
      addressArr:[],
      typeArr:[],
      workList:[]
    }
  },
  mounted() {
      this.getDictList()
      this.fetchData()
  },
  methods: {
    getDictList(){
      // 工作地点
      let work_address = 'work_address'
      fetchDict(work_address).then(res=>{
        this.addressArr = res.data
      })
      // 岗位类型
      let post_type = 'post_type'
      fetchDict(post_type).then(res=>{
        this.typeArr = res.data
      })
    },
    getDictText(arr,type){
      for(let item of arr){
        if(item.value == type){
          return item.label
        }
      }
    },
    fetchData(){
      fetchList(this.query).then(res=>{
          let data = res.data
          data.records.forEach(record =>{
            record.createTime = formatTime(record.createTime,'yyyy-MM-dd')
          })
          this.workList = data.records
      })
    },
    /**
     * 职位搜索
     */
    onSearch(){
      this.fetchData()
    },
    changeHandle(e){
      this.fetchData()
    },
    workClick(item,index){
      const routeData = this.$router.resolve({
        path: '/joindetail', // 假设已经定义了名为NewPage的路由
        query: {
          id: item.id
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style>
  @import "../../styles/join.css";
</style>
<style lang="scss" scoped>
.work-search{
  ::v-deep .el-input__inner{
    border-radius: 0;
  }
  ::v-deep .el-button{
    border-radius: 0;
  }
  ::v-deep .el-button--primary{
    background-color: #3063A3;
    border-color: #3063A3;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #3063A3;
  }
}
</style>
